import { generateUseUseSettings } from './generateUseUsingSettings';

/** PolicyStream demo host — WL row slug from the backend. */
export const useUsingCheapCharlieSettings = generateUseUseSettings({
  slug: 'cheapcharliesinsurance',
});
